<template>
  <div class="show_custom">
    <div class="showCityandRule-1">
      <p class="th">
        <span>{{introtit}}</span>
        <img src="//static.daojia.com/fe/jz/daojiaapp/hongbao/image/guide-title.eb435f99.png" alt="">
        <em @click="hideEvent"></em>
      </p>
      <div class="wrapper">
        <pre>{{intro}}</pre>
        <a href="javascript:;" class="know" @click="hideEvent">我知道了</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['introtit','intro'],
  methods: {
    hideEvent() {
      var that = this;
      that.$dispatch('aboutFlagEvent',false);
    }
  }
}
</script>



// WEBPACK FOOTER //
// About.vue?bf5ba372